import React from 'react'
import Banner from "./banner"
import Products from "./products"
import { Helmet } from 'react-helmet';


function index() {
    return (
        <>
            <Helmet>
                <title>Explore Online Store Templates & Features | Ecom Shop</title>
                <meta name="description" content="Browse a range of customizable e-commerce website templates and features designed for fast, secure, and mobile-friendly online stores. Perfect for growing businesses." />
            </Helmet>
            <div className='shop'>
                <Banner />
                <Products />
            </div>
        </>

    )
}

export default index